import styled from 'styled-components';
import { color } from '@stockbit/ui';

export const SpecialMonitoringBannerContainer = styled.div`
  margin: 5px 0 10px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fef4e8;
  border: 0.5px solid #f5931b;
  border-radius: 4px;
  cursor: pointer;

  p {
    margin-bottom: 0;
  }

  i {
    color: #f5931b;
    font-weight: 700;
  }
`;

export const SpecialMonitoringBannerContent = styled.div`
  flex: 1;

  .special-monitoring-banner__title {
    display: flex;
    align-items: center;
    margin-bottom: 4px !important;

    & > span {
      font-size: 12px;
      line-height: 16px;
      color: ${color.highgray};
    }
  }

  .special-monitoring-banner__desc {
    font-size: 12px;
    line-height: 16px;
    color: ${color.highempahis};
  }
`;
